<template>
  <div class="radio-raw" v-for="option in options" :key="option.id">
    <input
      type="radio"
      :name="name"
      :id="`${name}-${option.id}`"
      :value="option.id"
      @change="updateState($event)"
      :checked="state.answers[stateKey] === option.id"
    />
    <label :for="`${name}-${option.id}`">
      <span class="custom-radio"></span>
      {{ option.text }}
    </label>
  </div>
</template>

<script>
import { state } from '@/lib/state'
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    stateKey: {
      type: String,
      required: true,
    },
  },
  emits: ['input'],
  data: function () {
    return {
      state: state,
    }
  },
  mounted() {
    // Set the initial value of state if it doesn't exist
    if (!this.state.answers[this.stateKey] && this.options.length > 0) {
      const initialOption = this.options[0]

      this.state.answers[this.stateKey] = initialOption.id

      if (!this.state.displayAnswers) {
        this.state.displayAnswers = {}
      }

      // Store the display text
      this.state.displayAnswers[this.stateKey] = initialOption.text
    }
  },
  methods: {
    updateState(event) {
      const id = event.target.value
      const selectedOption = this.options.find((option) => option.id.toString() === id)

      // Ensure displayAnswers exists
      this.state.displayAnswers = this.state.displayAnswers || {}

      // Store text and id
      this.state.answers[this.stateKey] = selectedOption?.id ?? null
      this.state.displayAnswers[this.stateKey] = selectedOption?.text ?? null

      // Emit events
      this.$emit('input', selectedOption?.id)
      this.emitter.emit(`validate-${this.stateKey}`)
    },
  },
}
</script>

<style lang="postcss" scoped>
.radio-raw {
  display: flex;
  gap: 8px;
  align-items: center;

  input[type='radio'] {
    display: none; /* Hide the default radio button */
  }

  label {
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 8px;
  }

  .custom-radio {
    width: 16px;
    height: 16px;
    border: 2px solid #000;
    border-radius: 50%;
    position: relative;
    display: inline-block;
  }

  /* Style for the checked state */
  input[type='radio']:checked + label .custom-radio {
    background-color: #000;
  }

  /* Add a small dot inside for the checked state */
  input[type='radio']:checked + label .custom-radio::after {
    content: '';
    width: 8px;
    height: 8px;
    background-color: #fff;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
